<template>
  <div class="header">
    <div class="header_1 cf">
      <a href="/" class="logo lf"><img src="../assets/image/logo.png"></a>
      <div class="header_2 cf rf">

        <!--<i @click="gotoPersonInfo" v-if='!0'>个人中心</i>-->
        <!--<div class="login_box">-->
          <!--<i>登录</i>-->
          <!--<i>注册</i>-->
        <!--</div>-->
        <!--<i class="yy_box">-->
          <!--<img style="height: 20px" src="../assets/image/header_yy.png"/>-->
          <!--&nbsp;中&nbsp;文&nbsp;-->
          <!--<img style="height: 7px;" src="../assets/image/header_xl.png"/>-->
        <!--</i>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topHeader',
  data () {
    return {
    }
  },
  methods: {
    gotoPersonInfo(){
      // this.$router.push({path:'/my_personal_data'})
    },
    gotoPersonInfoLogin(){
      // this.$store.commit('SET_LOGIN', true)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue